/**
 * @/lib ラッパー（integrations 除外）
 * 独立化時はここを packages/shared/* に差し替える
 */
export * from '@/lib/auth/auth-client'
export * from '@/lib/auth/validate-profile'
